import React from "react";
import { Link } from "react-router-dom";

interface ListingCardSkeletonProps {
  size?: "default" | "small";
  className?: string;
}

const ListingCardSkeleton: React.FC<ListingCardSkeletonProps> = ({
  size = "default",
  className = "",
}) => {
  const renderSliderSkeleton = () => (
    <div className="relative w-full h-48 bg-gray-200 animate-pulse rounded-t-2xl"></div>
  );

  const renderContentSkeleton = () => (
    <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
      <div className="space-y-2">
        <div className="flex items-center space-x-1.5">
          <div className="h-4 w-6 bg-gray-300 rounded animate-pulse"></div>
          <div className="h-4 w-6 bg-gray-300 rounded animate-pulse"></div>
          <div className="h-4 w-6 bg-gray-300 rounded animate-pulse"></div>
        </div>

        <div className="flex items-center space-x-2">
          <div className="h-5 w-20 bg-gray-300 rounded-full animate-pulse"></div>
          <div className="h-5 w-32 bg-gray-300 rounded animate-pulse"></div>
        </div>
        <div className="flex items-center space-x-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-300 animate-pulse"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          <div className="h-4 w-24 bg-gray-300 rounded animate-pulse"></div>
        </div>
      </div>
      <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
      <div className="flex justify-between items-center">
        <div className="h-6 w-16 bg-gray-300 rounded animate-pulse"></div>
        <div className="h-5 w-24 bg-gray-300 rounded-full animate-pulse"></div>
      </div>
    </div>
  );

  return (
    <div
      className={`
        nc-StayCardSkeleton 
        group 
        relative 
        drop-shadow-sm
        bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 
        rounded-2xl 
        overflow-hidden 
        ${className}`}
      data-nc-id="StayCardSkeleton"
    >
      {renderSliderSkeleton()}
      <Link to="#">{renderContentSkeleton()}</Link>
    </div>
  );
};

export default ListingCardSkeleton;